import api from "../api";
import { API_URL } from "../constants";

export const getMetricsByDeployId = async (
  id: string,
  startTime: number,
  endTime: number,
) => {
  return api.get(
    `${API_URL}/v1/metric/deploy/${id}?startTime=${startTime}&endTime=${endTime}&limit=1000`,
  );
};
